import { IBlock, ITemplateBlock } from './blocks/blockInterfaces'
import { BlockType } from './constants/BlockType'

export const isMessageTemplateBlock = (block: IBlock): block is ITemplateBlock =>
  block.type === BlockType.MESSAGE_TEMPLATE
